export default {
  methods: {

    draw_Forms() {
      this.canvasForms = this.svg
      .append('g')
      .attr('transform', `translate(0.5, 0.5)`)
      .style('font-family', 'roboto')
      .attr('cursor', 'default')
      
      this.draw_Chart()

      if(this.table.visible == 'Y') {
        this.draw_Header()
        this.draw_Table()
      }

      if (this.sundries) {
        let sunData = this.JQueries.sundriesConfig && this.JQueries.sundriesConfig.SQL ? this.Queries[this.JQueries.sundriesConfig.SQL][0] : this.DataItems[0]
        if(this.sundries.length > 0) this.gmx_Sundries(this.svg, this.sundries, sunData, this.JQueries.sundriesConfig.server)
      }
    },

    draw_Line(selection, x1_, x2_, y1_, y2_, stroke_) {
      selection
      .append('line')
      .attr('x1', x1_).attr('x2', x2_)
      .attr('y1', y1_).attr('y2', y2_)
      .attr('stroke', stroke_)
      .attr('stroke-width', .5)
    },


    draw_Text(selection, id_, x_, y_, tSize_, tColor_, align_, txt_) {
      selection
      .append('text')
      .attr('id', id_)
      .attr('x', x_).attr('y', y_ + tSize_*0.36)
      .attr('font-size', tSize_).attr('text-anchor', align_)
      .attr('fill', tColor_)
      .text(txt_)
    },

    
  }
}